<ng-container *ngIf="viewModel$ | async as viewModel">

  <mat-sidenav-container  color="primary"  class="sidenav-container">
    <!--fullscreen-->
    <mat-sidenav #sidenav="matSidenav"  mode="side" class="sidenav" [opened]=true [class.opened]="isOpen" [class.closed]="!isOpen">
    <div class="sidemenu_container">
      <mat-nav-list>
        <ng-container *ngIf="isOpen">
          <img src="./assets/images/Platform_Logo.svg" alt="Full Logo" class="logo_text" />
        </ng-container>

        <ng-container *ngIf="!isOpen">
          <img src="./assets/images/Favicon_Logo.svg" alt="Full Logo" class="logo_no_text" />
        </ng-container>
      </mat-nav-list>

      <mat-divider></mat-divider>

      <div class="coredata"><mat-icon>data_usage</mat-icon> {{ isOpen ? appKey : ''}}</div>

      <mat-nav-list>
 <!-- <a mat-list-item [routerLink]="menuItem.routerLink" routerLinkActive="active" matTooltip="{{ menuItem.label }}"
          matTooltipPosition="right" [matTooltipDisabled]="isMenuOpen()">
          <mat-icon matListItemIcon>{{ menuItem.icon }}</mat-icon>
          <span matListItemTitle class="!text-white">{{ menuItem.label }}</span>
        </a> -->
        <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase()] " routerLinkActive="active"
          (click)="isMobile && sidenav.close(); isOpen = true" data-testid="Dashboard">
          <fa-icon [icon]="['fas', 'gauge']"></fa-icon>Dashboard
        </a>

        <mat-expansion-panel #eventsPanel="matExpansionPanel" [class.mat-elevation-z0]="true" [hideToggle]="!isOpen">
          <mat-expansion-panel-header data-testid="Events" (click)="isOpen = true">
            <fa-icon [icon]="['fas', 'calendar']"></fa-icon>Events
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item appAuthorizeControl="view||navbar" routerLinkActive="active"
              [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/events']"
              (click)="isMobile && sidenav.close(); isOpen = true">
              <fa-icon [icon]="['fas', 'calendar']" data-testid="Event Sub-option"></fa-icon>Events
            </a>

            <a mat-list-item appAuthorizeControl="edit||navbar" routerLinkActive="active"
              [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/offertags']"
              (click)="isMobile && sidenav.close(); isOpen = true" data-testid="Offer Tags">
              <fa-icon [icon]="['fas', 'tags']"></fa-icon>Offer Tags
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel #couponsPanel="matExpansionPanel" [class.mat-elevation-z0]="true" appAuthorizeControl="admin||navbar" [hideToggle]="!isOpen">
          <mat-expansion-panel-header data-testid="Coupons"><fa-icon [icon]="['fas', 'money-check-dollar']" (click)="isOpen = true"></fa-icon>Coupons
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/coupons']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="admin||navbar" data-testid="Coupons">
              <fa-icon [icon]="['fas', 'money-check-dollar']"></fa-icon>Coupons
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/shoppers']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="admin||navbar" data-testid="Shoppers">
              <mat-icon>shopping_basket</mat-icon>Shoppers
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- <mat-expansion-panel [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header data-testid="Channels" appAuthorizeControl="view||navbar">
            <fa-icon [icon]="['fas', 'rocket']"></fa-icon>Channels
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/digitalads']"
              (click)="isMobile && sidenav.close()">
              <fa-icon [icon]="['fas', 'tachograph-digital']" data-testid="Digital Ads"></fa-icon>Digital Ads
            </a>
          </mat-nav-list>
        </mat-expansion-panel> -->

        <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/assets']" routerLinkActive="active"
          (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="edit||navbar" data-testid="Assets">
          <fa-icon [icon]="['fas', 'image']"></fa-icon>Assets
        </a>

        <mat-expansion-panel #productsPanel="matExpansionPanel" [class.mat-elevation-z0]="true" appAuthorizeControl="admin||navbar" [hideToggle]="!isOpen">
          <mat-expansion-panel-header data-testid="Products">
            <fa-icon [icon]="['fas', 'barcode']" (click)="isOpen = true"></fa-icon>Products
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/products']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" data-testid="Products Sub-option">
              <fa-icon [icon]="['fas', 'barcode']"></fa-icon>Products
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/product-brands']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="admin||navbar" data-testid="Brands">
              <fa-icon [icon]="['fas', 'trademark']"></fa-icon>Brands
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/product-categories']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="admin||navbar" data-testid="Categories">
              <fa-icon [icon]="['fas', 'folder-tree']"></fa-icon>Categories
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/vendors']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="admin||navbar" data-testid="Vendors">
              <fa-icon [icon]="['fas', 'users']"></fa-icon>Vendors
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel #organizationPanel="matExpansionPanel" [class.mat-elevation-z0]="true" appAuthorizeControl="admin||navbar" [hideToggle]="!isOpen">
          <mat-expansion-panel-header data-testid="Organization" (click)="isOpen = true">
            <fa-icon [icon]="['fas', 'building']"></fa-icon>Organization
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/divisions']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="admin||navbar" data-testid="Divisions">
              <fa-icon [icon]="['fas', 'chart-pie']"></fa-icon>Divisions
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/eventtypes']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="admin||navbar" data-testid="Event Types">
              <fa-icon [icon]="['fas', 'receipt']"></fa-icon>Event Types
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/banners']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="admin||navbar" data-testid="Banners">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                fill="#e8eaed">
                <path
                  d="M200-80v-800h80v80h560l-80 200 80 200H280v320h-80Zm300-440q33 0 56.5-23.5T580-600q0-33-23.5-56.5T500-680q-33 0-56.5 23.5T420-600q0 33 23.5 56.5T500-520Z" />
              </svg>Banners
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase() + '/stores']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" appAuthorizeControl="admin||navbar" data-testid="Stores">
              <fa-icon [icon]="['fas', 'shop']"></fa-icon>Stores
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase(), 'print-attributes']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" data-testid="Print Attributes">
              <i class="fa-solid fa-print"></i>Print Attributes
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-expansion-panel #administrationPanel="matExpansionPanel" [class.mat-elevation-z0]="true" appAuthorizeControl="admin||navbar" [hideToggle]="!isOpen">
          <mat-expansion-panel-header data-testid="Administration" (click)="isOpen = true">
            <fa-icon [icon]="['fas', 'cog']"></fa-icon>Administration
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase(),'settings']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" data-testid="User Management">
              <fa-icon [icon]="['fas', 'cog']"></fa-icon>Settings
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase(),'user-management']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" data-testid="User Management">
              <fa-icon [icon]="['fas', 'user']"></fa-icon>Users
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase(), 'workflow-management']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" data-testid="Workflow Management">
              <fa-icon [icon]="['fas', 'folder-tree']"></fa-icon>Workflow
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase(), 'data-feed-monitor']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" data-testid="Workflow Management">
              <i class="fa-solid fa-arrows-rotate"></i>Data Feed
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase(), 'custom-fields']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" data-testid="Workflow Management">
              <i class="fa-solid fa-sliders"></i>Custom Fields
            </a>
            <a mat-list-item [routerLink]="[viewModel.organization?.name?.toLowerCase(), 'store-attribute-types']" routerLinkActive="active"
              (click)="isMobile && sidenav.close(); isOpen = true" data-testid="Store Attribute Types">
              <i class="fa-solid fa-tags"></i>Store Attribute Types
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
        
      </mat-nav-list>
      <div class="menu-spacer"></div>
      <mat-divider></mat-divider>
         <mat-nav-list>
      
        <a mat-list-item [class.opened]="isOpen" [class.closed]="!isOpen" routerLinkActive="active"
          (click)="isOpen = !isOpen; eventsPanel.close(); couponsPanel.close(); productsPanel.close(); organizationPanel.close(); administrationPanel.close();">

           <img  src="./assets/images/collapse_icon.svg"  [ngClass]="{'rotated': !isOpen}" class="collapse_icon" />
          <!-- <fa-icon [icon]="['fas', 'chevron-left']" style="margin-right: 15px; font-size: 16px;"></fa-icon> -->

            <span [ngClass]="{'hidden': !isOpen} ">Collapse</span> 
        </a>
        <mat-divider></mat-divider>
         <ng-container *ngIf="viewModel.helpDocUrl; else helpFallback">
           <a mat-list-item [class.opened]="isOpen" [class.closed]="!isOpen"
             [href]="viewModel.helpDocUrl" target="_blank" rel="noopener noreferrer">
             <fa-icon [icon]="['fas', 'question-circle']"></fa-icon>
             <span [ngClass]="{'hidden': !isOpen}">Help</span>
           </a>
         </ng-container>
         <ng-template #helpFallback>
           <a mat-list-item [class.opened]="isOpen" [class.closed]="!isOpen" routerLinkActive="active"
             (click)="isOpen = !isOpen">
             <fa-icon [icon]="['fas', 'question-circle']"></fa-icon>
             Help
           </a>
         </ng-template>
      
      </mat-nav-list>
    </div>
  </mat-sidenav>
    <mat-sidenav-content [class.sidenav-opened]="isOpen" [class.sidenav-closed]="!isOpen">
      <lib-header (toggleSidenav)="isOpen = !isOpen"></lib-header>
      <div class="notification-banner" *ngIf="showBanner == true">
        <div class="flex-row-align-center">
          <div><mat-icon>warning</mat-icon></div>
          <p>
            You do not have permission to access this stage of the Workflow Event. Please contact the Event Admin.
          </p>
        </div>
        <div class="banner-actions flex-row-align-center">
          <div class="banner-action-btn" (click)="hideBanner()">
            DISMISS
          </div>
          <div class="banner-action-btn" (click)="hideBanner()">
            REQUEST ACCESS
          </div>
        </div>
      </div>

      <div class="main-content-container">
        <div class="breadcrumbs-bar" fxLayout="row" fxLayoutAlign="space-between center" fxHide.xs>
          <div class="breadcrumbs">
            <xng-breadcrumb></xng-breadcrumb>
            <!-- <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start">
              <p>Workflow Name: [Stage Name]</p> <button mat-raised-button class="mark_complete_btn">
                <mat-icon>check_circle_outline</mat-icon>
                Mark Complete
              </button>
            </div> -->
          </div>
          <div class="breadcrumbs-actions" fxLayout="row" fxLayoutGap="12px" *ngIf="breadcrumbActions$ | async as actions">
            <ng-container *ngFor="let action of actions">
              <button
                type="button"
                class="sat-btn"
                [ngClass]="action.buttonClass === 'filled' ? 'sat-btn--primary' : 'sat-btn--outline'"
                (click)="onBreadcrumbAction(action.id)">
                {{ action.label }}
              </button>
            </ng-container>
          </div>
        </div>
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <app-spinner-overlay></app-spinner-overlay>
</ng-container>
